import React, { useEffect, useState } from "react";
import { Card, Table, Button, Form } from "react-bootstrap";
import { getAllClientByUsers } from "../../services/Login_service";
import { updateUserPoints } from "../../services/Payment_service"; 
import type { UserModel } from "../../models/UserModel";
import { format } from "date-fns";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { updateUser } from "../../userSlice";
import EmailModal from "./EmailModal";
import { FaSave, FaPen } from 'react-icons/fa';

const UserPointsList: React.FC = () => {
  const [users, setUsers] = useState<UserModel[]>([]);
  const [loading, setLoading] = useState(true);
  const [editingUserId, setEditingUserId] = useState<number | null>(null);
  const [newPoints, setNewPoints] = useState<number>(0);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState<UserModel | null>(null);

  const dispatch = useDispatch();

  const fetchUsers = async () => {
    try {
      const userId = Number(localStorage.getItem("userId"));
      if (!userId) return;

      const allUsers = await getAllClientByUsers(userId);
      const filteredUsers = allUsers.filter(
        (u) => u.status !== "anonymous" && u.role !== "ADMIN"
      );

      setUsers(filteredUsers);
    } catch (error) {
      console.error("Erreur lors de la récupération des utilisateurs :", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleEditClick = (userId: number, currentPoints: number) => {
    setEditingUserId(userId);
    setNewPoints(currentPoints);
  };

const handleSaveClick = async (userId: number) => {
  try {
    const user = users.find((u) => u.id === userId) ?? null;
    if (!user) return;

    const oldPointsValue = user.points_balance; 

    await updateUserPoints(userId.toString(), newPoints, dispatch);

    toast.success("Points mis à jour !");

    setSelectedUser({
      ...user,
      oldPoints: oldPointsValue,
      newPoints: newPoints,
    });

    setShowEmailModal(true);

    setUsers((prev) =>
      prev.map((u) =>
        u.id === userId ? { ...u, points_balance: newPoints } : u
      )
    );

    setEditingUserId(null);
  } catch (error) {
    toast.error("Erreur lors de la mise à jour des points");
  }
};



  if (loading) return <p>Chargement des utilisateurs...</p>;
  
  return (
    
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Card className="p-7" style={{ width: "100%", maxWidth: "900px" }}>
        <Card.Title className="text-center" style={{ margin: "20px", fontSize: "25px" }}>
          LISTE DES POINTS DES UTILISATEURS
        </Card.Title>
        <div style={{ width: "100%", overflowX: "auto" }}>
          <Table
            striped
            bordered
            hover
            responsive
            style={{ minWidth: "700px", textAlign: "center", margin: "0 auto",maxHeight: "500px", overflowY: "auto" }}
          >
            <thead>
              <tr>
                <th>Nom & Prénom</th>
                <th>Email</th>
                <th>Référence</th>
                <th>Date d'inscription</th>
                <th>Solde points</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>{user.firstname} {user.name}</td>
                  <td>{user.email}</td>
                  <td>{user.reference}</td>
                  <td>{format(new Date(user.createdAt), "dd/MM/yyyy")}</td>
                  <td>
                    {editingUserId === user.id ? (
                      <Form.Control
                        type="number"
                        value={newPoints}
                        onChange={(e) => setNewPoints(Number(e.target.value))}
                        style={{ width: "100px", display: "inline" }}
                      />
                    ) : (
                      user.points_balance ?? 0
                    )}
                  </td>
                  <td>
                    {editingUserId === user.id ? (
                      <Button size="sm" onClick={() => handleSaveClick(user.id)}>
                        <FaSave /> 
                      </Button>
                    ) : (
                      <Button
                        size="sm"
                        // style={{ color: '#4BB0C0', background: 'transparent !important' }}
                        onClick={() => handleEditClick(user.id, user.points_balance ?? 0)}
                      >
                        <FaPen />
                      </Button>
                    )}
                  </td>

                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        {showEmailModal && selectedUser && (
          <EmailModal
            show={showEmailModal}
            onClose={() => setShowEmailModal(false)}
            recipientName={`${selectedUser.firstname} ${selectedUser.name}`}
            recipientEmail={selectedUser.email}
            currentUserEmail={localStorage.getItem("userEmail") || ""}
            fromUserListPoint={true}
            oldPoints={selectedUser.oldPoints}
            newPoints={selectedUser.newPoints}
          />
        )}
      </Card>
    </div>
    
  );
};

export default UserPointsList;
